<template>
  <div class="flex align-center justify-center flex-direction bg-white text-black" style="overflow-x: hidden">
    <homeHeader></homeHeader>
    <div class="produce-mask flex align-center justify-between">
      <div class="produce-mask-opt">
        <div class="produce-mask-title">不止于 征集</div>
        <div class="produce-but flex align-center justify-center" @click="createQrcode">
          免费使用
          <div class="produce-but-icon"></div>
        </div>
      </div>
      <img src="https://assets.pfotoo.com/PC/1/%E7%BC%96%E7%BB%84%2014@2x.png" class="produce-mask-img">
    </div>
    <div class="text-500" style="font-size: 30px; margin-top: 120px; margin-bottom: 80px;">使用起来 开心愉悦</div>
    <div class="flex align-center flex-direction produce-view">
      <div style="padding: 0 50px;width: 100%;box-sizing: border-box;"
           class="flex align-center justify-between">
        <div class="flex flex-direction align-center justify-center">
          <div class="icon-free icon-1"></div>
          <div class="text-600 flex flex-direction align-center justify-center" style="font-size: 24px;">
            <div>免费享有</div><div>大容量存储</div>
          </div>
        </div>

        <div class="flex flex-direction align-center justify-center">
          <div class="icon-free icon-2"></div>
          <div class="text-600 flex flex-direction align-center justify-center" style="font-size: 24px;">
            <div>免费享有</div><div>参与人数无上限</div>
          </div>
        </div>

        <div class="flex flex-direction align-center justify-center">
          <div class="icon-free icon-3"></div>
          <div class="text-600 flex flex-direction align-center justify-center" style="font-size: 24px;">
            <div>免费享有</div><div>上传数量无上限</div>
          </div>
        </div>
      </div>

      <div class="produce-more flex align-center justify-center flex-direction">
        <div class="produce-more-name">更多功能</div>
        <div class="flex align-center justify-around" style="width: 100%;">
          <div class="produce-more-item flex flex-direction align-center justify-center" v-for="item in mores">
            <img :src="item.icon" style="width: 80px;height: 80px;">
            <div class="name" style="white-space: pre-wrap;">{{item.name}}</div>
          </div>
        </div>
      </div>
      <div class="produce-privacy flex-direction flex align-center justify-center text-500">
        <div style="font-size: 40px;margin-bottom: 50px;">我们不贩卖个人隐私数据</div>
        <div style="font-size: 24px;">我们极其在乎你的隐私，绝不通过售卖你的隐私数据给第三方获利。</div>
      </div>
    </div>
    <homeFooter></homeFooter>
    <el-dialog
            title="创建活动" class="fotoo"
            :visible.sync="dialogVisible"
            width="50%" append-to-body
            :before-close="handleClose">
      <div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="　微信　" name="wechat">
            <div class="block" style="text-align: center;">
              <el-image :src="codeurl">
                <div slot="placeholder" class="image-slot">
                  加载中<span class="dot">...</span>
                </div>
              </el-image>
              <div class="demonstration" style="margin-top: 20px;">使用微信，扫一扫</div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import App from '../util/comfun'
  import homeHeader from '../pages/components/home/header.vue'
  import homeFooter from '../pages/components/home/footer.vue'
  export default {
    data () {
      return {
        codeurl:'',
        dialogVisible:false,
        activeName: 'wechat',
        mores:[
          {icon:'https://assets.pfotoo.com/PC/%E7%BC%96%E7%BB%84%209@2x.png',name:'公众号\n引流增粉'},
          {icon:'https://assets.pfotoo.com/PC/%E7%BC%96%E7%BB%84%2010@2x.png',name:'大众投票'},
          {icon:'https://assets.pfotoo.com/PC/%E7%BC%96%E7%BB%84%2011@2x.png',name:'在线评选'},
          {icon:'https://assets.pfotoo.com/PC/%E7%BC%96%E7%BB%84%2012@2x.png',name:'渠道二维码'},
          {icon:'https://assets.pfotoo.com/PC/%E7%BC%96%E7%BB%84%2013@2x.png',name:'表单自定义'},
        ]
      }
    },
    components:{
      homeHeader,
      homeFooter,
    },
    methods:{
      async createQrcode(){
        if(!this.codeurl){
          this.codeurl=await App.System.Qrcode({
            autoColor:false,
            inHyaline:false,
            lineColor:'0,0,0',
            page:'pages/enter/enter',
            scene:'//mm',
            width:300
          },'URL')
        }
        this.dialogVisible=true
      },
      handleClose(done) {
        done();
      },
      handleClick(tab, event) {
        console.log(tab, event);
      }
    },
    mounted(){

    },

  }
</script>

<style>
.produce-mask{
  width: 100%;
  height: 750px;
  background-image: url("https://assets.pfotoo.com/PC/1/%E8%83%8C%E6%99%AF%E5%9B%BE.png");
  background-size: 100% 100%;
  padding: 0 8vw;
  box-sizing: border-box;
}
.produce-view{
  width: 1024px;
  box-sizing: border-box;
}
.produce-view .icon-free{
    width: 150px;
    height: 150px;
    background-size: 100% 100%;
    margin-bottom: 50px;
  }
.produce-view .icon-1{
  background-image: url("https://assets.pfotoo.com/PC/%E7%BC%96%E7%BB%84%207@2x.png");
}
.produce-view .icon-2{
  background-image: url("https://assets.pfotoo.com/PC/%E7%BC%96%E7%BB%84%202@2x.png");
}
.produce-view .icon-3{
  background-image: url("https://assets.pfotoo.com/PC/%E7%BC%96%E7%BB%84%208@2x.png");
}
  .produce-more{
    width: 100%;
    height: 520px;
    background: linear-gradient(331deg,#7aecdc 3%, #45d5b6 81%);
    border-radius: 10px;
    margin: 120px 0 120px;
    box-sizing: border-box;
    padding: 0 50px;
  }
  .produce-privacy{
    width: 100%;
    height: 330px;
    background: #fbfbfb;
  }
  .produce-more-name{
    width: 120px;
    height: 46px;
    font-size: 30px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    color: #ffffff;
    line-height: 46px;
    margin-bottom: 80px;
  }
  .produce-more-item{
    width: 150px;
    height: 230px;
    background: #ffffff;
    border-radius: 10px 42px 10px 42px;
  }
.produce-more-item .name{
  font-size: 20px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: center;
  color: #5d5d5d;
  line-height: 28px;
  margin-top: 20px;
}
  .produce-mask-title{
    width: 267px;
    height: 46px;
    font-size: 50px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    color: #ffffff;
    line-height: 46px;
  }
.produce-but{
  width: 300px;
  height: 90px;
  background: #3dc4a7;
  border-radius: 8px;
  margin-top: 189px;

  font-size: 28px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  color: #ffffff;
}
  .produce-but-icon{
    width: 26px;
    height: 26px;
    background-size: 100% 100%;
    background-image: url("https://assets.pfotoo.com/PC/%E5%8F%B3%E7%AE%AD%E5%A4%B4@2x.png");
    margin-left: 22px;
    margin-top: 5px;
  }
  .produce-mask-img{
    background-color: #fefefe;
    border-radius: 10px;
    padding: 60px 20px 20px 40px;
    width: 533px;
    height: 355px;
  }
</style>


// WEBPACK FOOTER //
// src/pages/produce.vue